import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Zalo } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ZaloModule extends VuexModule {
    @Action
    [Zalo.uploadArticleToOA](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/zalo/uploadArticleToOA`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Zalo.broadcastOAPost](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/zalo/broadcastOAPost`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}